import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Borders, Colors, FontWeights } from '../../constants'

interface Props {
  className?: string
  onClose: () => void
  children: ReactNode
}

export function TooltipCloud({ className, onClose, children }: Props) {
  function onBackgroundClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <Anchor>
      <Overlay onClick={onBackgroundClick} />
      <Content className={className}>{children}</Content>
    </Anchor>
  )
}

const Overlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
`

const Anchor = styled.div`
  position: relative;
`

const Content = styled.div`
  padding: 5px 8px;
  position: absolute;
  display: inline-block;
  width: 180px;
  font-size: 11px;
  font-weight: ${FontWeights.Regular};
  border: 1px solid ${Borders.LightColor};
  border-radius: ${Borders.Radius};
  text-transform: none;
  background-color: ${Colors.White};
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 100000;

  p,
  ol,
  ul,
  table {
    margin: 0 0 4px 0;

    &:last-child {
      margin: 0;
    }
  }

  ol,
  ul {
    padding-left: 18px;
  }

  table {
    width: 100%;
  }
`
